import React, { useState } from 'react'

import { AssessmentForm } from './components'
import { Container, ContentHeader, LoadingFeedback, Page } from 'components'

const ThirdPartyAssessmentMain = () => {
  const [loading, setLoading] = useState(false)

  return (
    <Page title="Solicitar Parecer de Avaliação Recebidas">
      <LoadingFeedback open={loading} />
      <Container maxWidth={false}>
        <ContentHeader title="Solicitar Parecer de Avaliação Recebidas" />
        <AssessmentForm setLoading={setLoading} />
      </Container>
    </Page>
  )
}

export default ThirdPartyAssessmentMain
